import React from 'react';
import UIAvatarImage from '@/components/shared/UIAvatarImage';
import './UIChatMessage.scss';

export interface UIChatMessageProps {
  text: string;
  timestamp: string;
  isOwn: boolean;
  sender: {
    name: string;
    avatar?: string | null;
  };
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const baseClass = 'UIChatMessage';

const UIChatMessage: React.FC<UIChatMessageProps> = ({
                                                       text,
                                                       timestamp,
                                                       isOwn,
                                                       sender,
                                                       size = 'medium',
                                                       className = '',
                                                     }) => {
  const containerClasses = [
    baseClass,
    `${baseClass}--${size}`,
    isOwn ? `${baseClass}--sent` : `${baseClass}--received`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      <div className={`${baseClass}__avatar-container`}>
        <UIAvatarImage
          avatar={sender.avatar}
          alt={sender.name}
          size={size}
        />
      </div>

      <div className={`${baseClass}__content`}>
        <div className={`${baseClass}__text`}>
          {text}
        </div>
        <div className={`${baseClass}__timestamp`}>
          {timestamp}
        </div>
      </div>
    </div>
  );
};

export default UIChatMessage;
